import React, { useEffect } from 'react'

const SideBar = ({ activeScreen, setActiveScreen }) => {
  // For the Auditor, ensure Dashboard is not the default page.
  // If nothing is active yet, default to "view-all-sales" instead.
  useEffect(() => {
    if (!activeScreen) {
      setActiveScreen('view-all-sales')
    }
  }, [activeScreen, setActiveScreen])

  const handleMenuClick = (screen) => {
    setActiveScreen(screen)
  }

  const isActive = (screenOrScreens) => {
    if (Array.isArray(screenOrScreens)) {
      return screenOrScreens.includes(activeScreen) ? '' : 'collapsed'
    }
    return activeScreen === screenOrScreens ? '' : 'collapsed'
  }

  const isSubActive = (screen) => {
    return activeScreen === screen ? 'active' : ''
  }

  const isExpanded = (screens) => {
    return screens.includes(activeScreen) ? 'collapse show' : 'collapse'
  }

  // Ensure parent menus are expanded when a sub-item is active
  useEffect(() => {
    const menuMappings = {
      'view-all-sales': '#sales-audit-nav',
      'voided-sales': '#sales-audit-nav',
      'refunds': '#sales-audit-nav',
      'product-catalog': '#product-stock-nav',
      'stock-movement-history': '#product-stock-nav',
      'warehouse-stock-levels': '#product-stock-nav',
      'branch-stock-levels': '#product-stock-nav',
      'stock-transfers-audit': '#product-stock-nav',
      'supplier-receiving-audit': '#product-stock-nav',
      'activity-log': '#system-logs-nav',
      'login-log': '#system-logs-nav',
      'permission-changes': '#system-logs-nav'
    }

    const targetId = menuMappings[activeScreen]
    if (targetId) {
      const collapseElement = document.querySelector(targetId)
      if (collapseElement && window.bootstrap && window.bootstrap.Collapse) {
        let bsCollapse = window.bootstrap.Collapse.getInstance(collapseElement)
        if (!bsCollapse) {
          bsCollapse = new window.bootstrap.Collapse(collapseElement, { toggle: false })
        }
        if (!collapseElement.classList.contains('show')) {
          bsCollapse.show()
        }
      }
    }
  }, [activeScreen])

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
       
        
        {/* Sales Audit Report */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive(['view-all-sales', 'voided-sales', 'refunds'])}`}
            data-bs-target="#sales-audit-nav" 
            data-bs-toggle="collapse" 
            href="#"
            onClick={(e) => { e.preventDefault(); }}
          >
            <i className="bi bi-receipt-cutoff" />
            <span>Sales Audit Report</span>
            <i className="bi bi-chevron-down ms-auto" />
          </a>
          <ul id="sales-audit-nav" className={`nav-content ${isExpanded(['view-all-sales', 'voided-sales', 'refunds'])}`} data-bs-parent="#sidebar-nav">
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('view-all-sales'); }}
                className={isSubActive('view-all-sales')}
              >
                <i className="bi bi-circle" />
                <span>View All Sales</span>
              </a>
            </li>
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('voided-sales'); }}
                className={isSubActive('voided-sales')}
              >
                <i className="bi bi-circle" />
                <span>Voided Sales</span>
              </a>
            </li>
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('refunds'); }}
                className={isSubActive('refunds')}
              >
                <i className="bi bi-circle" />
                <span>Refunds</span>
              </a>
            </li>
          </ul>
        </li>{/* End Sales Audit Report Nav */}
        
    
        
      
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('adjustment-audit')}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('adjustment-audit'); }}
          >
            <i className="bi bi-arrow-left-right" />
            <span>Adjustment Audit</span>
          </a>
        </li>{/* End Adjustment Audit Nav */}
        
        
        
        {/* Product & Stock Verification */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive(['product-catalog', 'stock-movement-history', 'warehouse-stock-levels', 'branch-stock-levels', 'stock-transfers-audit', 'supplier-receiving-audit'])}`}
            data-bs-target="#product-stock-nav" 
            data-bs-toggle="collapse" 
            href="#"
            onClick={(e) => { e.preventDefault(); }}
          >
            <i className="bi bi-box-seam" />
            <span>Product & Stock </span>
            <i className="bi bi-chevron-down ms-auto" />
          </a>
          <ul id="product-stock-nav" className={`nav-content ${isExpanded(['product-catalog', 'stock-movement-history', 'warehouse-stock-levels', 'branch-stock-levels', 'stock-transfers-audit', 'supplier-receiving-audit'])}`} data-bs-parent="#sidebar-nav">
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('product-catalog'); }}
                className={isSubActive('product-catalog')}
              >
                <i className="bi bi-circle" />
                <span>Product Catalog</span>
              </a>
            </li>
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('stock-movement-history'); }}
                className={isSubActive('stock-movement-history')}
              >
                <i className="bi bi-circle" />
                <span>Stock Movement History</span>
              </a>
            </li>
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('warehouse-stock-levels'); }}
                className={isSubActive('warehouse-stock-levels')}
              >
                <i className="bi bi-circle" />
                <span>Warehouse Stock Levels</span>
              </a>
            </li>
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('branch-stock-levels'); }}
                className={isSubActive('branch-stock-levels')}
              >
                <i className="bi bi-circle" />
                <span>Branch Stock Levels</span>
              </a>
            </li>
           
           
          </ul>
        </li>{/* End Product & Stock Verification Nav */}
        
        {/* System Logs */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive(['activity-log', 'login-log', 'permission-changes'])}`}
            data-bs-target="#system-logs-nav" 
            data-bs-toggle="collapse" 
            href="#"
            onClick={(e) => { e.preventDefault(); }}
          >
            <i className="bi bi-journal-text" />
            <span>System Logs</span>
            <i className="bi bi-chevron-down ms-auto" />
          </a>
          <ul id="system-logs-nav" className={`nav-content ${isExpanded(['activity-log', 'login-log', 'permission-changes'])}`} data-bs-parent="#sidebar-nav">
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('activity-log'); }}
                className={isSubActive('activity-log')}
              >
                <i className="bi bi-circle" />
                <span>Activity Log</span>
              </a>
            </li>
           
           
          </ul>
        </li>{/* End System Logs Nav */}
        
        {/* Reports */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('reports')}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('reports'); }}
          >
            <i className="bi bi-file-earmark-text" />
            <span>Reports</span>
          </a>
        </li>{/* End Reports Nav */}
        
        {/* Profile */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('profile')}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('profile'); }}
          >
            <i className="bi bi-person" />
            <span>Profile</span>
          </a>
        </li>{/* End Profile Nav */}
      </ul>
    </aside>
  )
}

export default SideBar